import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import './ClientProjectsSummaryItem.css';
import { Link } from 'react-router-dom';

export default function ClientProjectsSummaryItem({projectItem, backgroundStyle, user}) {

  return (
    <tr className={`ClientProjectsSummaryItem ${backgroundStyle}`}>
        { user &&
        <>
        <td className={`projNum ${backgroundStyle}`}>
            {projectItem.projNum? projectItem.projNum:'---'}
        </td>
        <td className='projType'>
            {projectItem.projType? capitalizeFirstLetter(projectItem.projType):'---'}
        </td>
        <td className='projTitle'>
            {projectItem.projTitle? capitalizeFirstLetter(projectItem.projTitle):'---'}
        </td>
        <td className='projectStatus status'>
            <div className={`statusContainer ${projectItem.projectStatus}`}>
                <div className={`statusColor ${projectItem.projectStatus}`}></div>
                <div className='statusText'>
                    <strong>
                        {projectItem.projectStatus === 'unassigned' ? 'Unassigned' : projectItem.projectStatus === 'inProgress' ? 'In Progress' : projectItem.projectStatus === 'inReview' ? 'In Review' : projectItem.projectStatus === 'completed' ? 'Complete' : projectItem.projectStatus === 'cancelled' ? 'Cancelled' : ''}
                    </strong>
                </div>
            </div>
        </td>
        <td className='clientNumber'>
            {projectItem.clientNumber? projectItem.clientNumber:'---'}
        </td>
        <td className='clientName'>
            { ['admin', 'manager'].includes(user.userType) ?
            <Link to={`/clients/${projectItem.clientID}`}>
                {projectItem.clientName? capitalizeFirstLetter(projectItem.clientName):'---'}
            </Link>
            :
            <div>
                {projectItem.clientName? capitalizeFirstLetter(projectItem.clientName):'---'}
            </div>
            }
        </td>
        <td className='submissionDate'>
            <div>
                { projectItem.submissionDate ?
                new Date(projectItem.submissionDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
                :
                '---'
                }
            </div>
        </td>
        <td className='dueDate'>
            <div>
                { projectItem.dueDate ?
                new Date(projectItem.dueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
                : 
                '---'
                }
            </div>
        </td>
        <td className='clientDeadline'>
            <div>
                { projectItem.clientDeadline ?
                new Date(projectItem.clientDeadline).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
                : 
                '---'
                }
            </div>
        </td>
        <td className='managerName'>
            {projectItem.managerName? capitalizeFirstLetter(projectItem.managerName):'---'}
        </td>
        <td className='assignedAnalystName'>
            {projectItem.assignedAnalystName? capitalizeFirstLetter(projectItem.assignedAnalystName):'---'}
        </td>
        <td className='createdAt'>
            <div>
                {new Date(projectItem.createdAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
            </div>
        </td>
        <td className='lastUpdate'>
            <div>
                {new Date(projectItem.updatedAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
            </div>
        </td>
        </>
        }
        
    </tr>
  )
}
